import * as bootstrap from 'bootstrap';
import { BaseModule } from "./base.module";

export class ToolTipModule extends BaseModule {
    initialize() {
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
        const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
    }
}